import React, { useEffect, useState } from "react";
import "./style.scss";
import "../../../../style/block.scss";
import "../../../../style/variables.scss";
import "../../../../style/buttons.scss";
import BasketTable from "../BasketTable";
import useBasketManager from "../../SaleMovie/CinemaHall/hooks/useBasketManager";
import useFinalizeManager from "../hooks/useFinalizeManager";
import BasketSummary from "../BasketSummary";
import BasketCodePromotion from "../BasketCodePromotion";
import { useSelector } from "react-redux";
import { State } from "../../../store";
import { BasketItem } from "../../../models/BasketItem";
import { PaymentLogos } from "../../../../features/PaymentLogo";
import useParentMessage from "../../../../utils/hooks/useParentMessage";
import { useTranslation } from "react-i18next";
import { MdArrowBackIosNew, MdOutlineKeyboardArrowLeft } from "react-icons/md";
import { useNavigate } from "react-router-dom";

interface IProps {
  setStep: (index: number) => void;
  handleDelete: (index: number) => void;
  handlePromotion: (promotionCode: string) => void;
  promoMessage: string;
  basket: BasketItem[];
  total: number;
  handleGetBasket: Function;
}

const BasketFirstStep: React.FC<IProps> = ({
  setStep,
  basket,
  total,
  handleDelete,
  handleGetBasket,
  handlePromotion,
  promoMessage
}: IProps) => {
  const { t } = useTranslation();
  const isLogging = useSelector((state: State) => state.auth.isLoggedIn);
  const { scrollToTop } = useParentMessage();
  const navigate = useNavigate();
  const homePage = sessionStorage.getItem("HomePage")

  const whichStep = () => {
    if (isLogging) {
      setStep(4);
    }
    if (!isLogging) {
      setStep(2);
    }
  };

  return (
    <React.Fragment>
      <div className="basket-first-step flex-between">
        <div className="basket shadow">
          <div className="basket-list">
            {basket.length > 0 ? (
              <BasketTable handleDelete={handleDelete} handleGetBasket={handleGetBasket} basket={basket} />
            ) : (
              <div className="alert alert-yellow">
                <b>{t("koszyk_jest_pusty")}</b>
              </div>
            )}
          </div>
        </div>
        <div className="summary">
          <div className="padding-big box border shadow ">
            <BasketSummary total={total} />
            {basket.length > 0 ? (
              <button
                onClick={() => {
                  whichStep();
                  scrollToTop();
                }}
                className="button button-fill-second big full-button move-up"
              >
                {t("przejdz_do_platnosci")}
              </button>
            ) : (
              <button className="button button-fill-disable big full-button">{t("przejdz_do_platnosci")}</button>
            )}

            {homePage && <button className="button button-fill-background-second big full-button"
              onClick={() => navigate(homePage)}
            >
              <MdOutlineKeyboardArrowLeft className="icon" />
              {t("dodaj_kolejne_bilety")}</button>
            }


            <PaymentLogos />
          </div>
          <div className="padding-big box border shadow">
            <BasketCodePromotion handlePromotion={handlePromotion} promoMessage={promoMessage} />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default BasketFirstStep;
